<template>
  <v-data-table
    item-key="id"
    :items-per-page="5"
    :headers="headers"
    :items="data"
    loading-text="Đang Tải"
    no-data-text="Không có dữ liệu"
  >
  </v-data-table>
</template>

<script>
import BaseSmallSelect from '@/components/basic/BaseSmallSelect.vue'
import BaseSmallInput from '@/components/basic/input/BaseSmallInput.vue'
export default {
  components: {
    BaseSmallSelect,
    BaseSmallInput,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dataFilter: [],
      items: [],
      headers: [
        {
          text: 'Mã học sinh',
          value: 'studentCode',
          align: 'left',
          sortable: false,
          width: '170px',
        },
        {
          text: 'Tên ngân hàng',
          value: 'bankCode',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Mã bin',
          value: 'bin',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Số tài khoản',
          value: 'accountNumber',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Tên tài khoản',
          value: 'accountName',
          align: 'left',
          sortable: false,
        },
      ],
    }
  },
  watch: {},
}
</script>

<style></style>
